import { UsersDataTable } from '@/components/(user_table)/components/UsersDataTable'
import { usersTableColumns } from '@/components/(user_table)/components/usersTableColumns'
import { DashboardHeader } from '@/components/dashboard/dashboard-header'
import { DashboardShell } from '@/components/dashboard/dashboard-shell'
import { Skeleton } from '@/components/ui/skeleton'
import { useTRPC } from '@/trpc/react'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/admin/users/')({
  component: RouteComponent,
})

function RouteComponent() {
  const api = useTRPC()

  const { data: usersInBusiness, isPending } = useQuery({
    ...api.user.getUsers.queryOptions(),
  })

  if (isPending)
    return (
      <DashboardShell>
        <DashboardHeader heading="Users" />
        <Skeleton className="h-40 w-full" />
      </DashboardShell>
    )

  if (!usersInBusiness) return <div>No users found</div>

  return (
    <DashboardShell>
      <DashboardHeader heading="Users" />
      <div className="rounded-md bg-violet-50 border border-violet-200 px-4 py-3 text-sm text-violet-800">
        <span className="font-medium">Note:</span> If you change a user's role, they will need to
        log out and log back in for the changes to take effect.
      </div>
      <UsersDataTable columns={usersTableColumns} data={usersInBusiness} />
    </DashboardShell>
  )
}
